<template>
  <div ref="gModal">
    <div class="modal fade in" tabindex="-1" role="dialog" @click="handleClickBackdrop">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <slot name="header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <img src="/assets/img/icons/close-modal.svg" alt="SOCO" />
              </button>
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body">
              <h1>Default Body Modal</h1>
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer"> </slot>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <div ref="gModalBackdrop" class="modal-backdrop fade in"></div>
  </div>
</template>

<script>
export default {
  name: 'g-modal',
  props: {
    noscroll: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  updated() {
    //this.checkingUpStateDocumentScrolling()
  },
  mounted() {
    //this.checkingUpStateDocumentScrolling()
  },
  beforeDestroy() {
    this.$SO('body').removeClass('no-scroll');
  },
  methods: {
    checkingUpStateDocumentScrolling() {
      if (this.$refs.gModal.style.display !== 'none' && !this.noscroll) {
        this.$SO('body').addClass('no-scroll');
      } else {
        this.$SO('body').removeClass('no-scroll');
      }
    },
    handleClickBackdrop(e) {
      const [content] = document.getElementsByClassName('modal-content');
      if (content) {
        const marginY = (window.innerHeight - content.clientHeight) / 2;
        const marginX = (window.innerWidth - content.clientWidth) / 2;
        const offset = {
          top: marginY,
          bottom: marginY + content.clientHeight,
          left: marginX,
          right: marginX + content.clientWidth,
        };
        // check if click outside of modal content
        if (e.x <= offset.left || e.x >= offset.right || e.y <= offset.top || e.y >= offset.bottom) {
          this.$emit('onclick-backdrop', e);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  align-items: center;
}
</style>
